import React, { useState } from "react";
import "./UserDisplay.css";
import IconAvatar from '@mui/icons-material/AccountCircle';
import { Menu, MenuItem, Divider, ListItemIcon } from '@mui/material';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import PersonIcon from '@mui/icons-material/PersonOutlined';
import { useNavigate } from 'react-router-dom';
import { DataProviderInstance } from "../../api/DataProvider";

function UserDisplay(props) {
    const { Name, Role, Picture } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    const { Logout } = DataProviderInstance();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        navigate('/profile');
        handleClose();
    };

    const handleSettings = () => {
        navigate('/settings');
        handleClose();
    };

    const handleLogout = () => {
        navigate('/logout');
        handleClose();
    };

    return (
        <>
            <div className="userDisplay" onClick={handleClick}>
                {Picture ?
                    <img src={Picture} alt="User" className="userDisplayImg" /> :
                    <IconAvatar className="userDisplayImg" />
                }
                <div className="userDisplayInfos">
                    <span>{Name}</span>
                    <p>{Role}</p>
                </div>
            </div>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    elevation: 3,
                    sx: {
                        borderRadius: 'var(--border-radius-sm)',
                        minWidth: 180,
                        overflow: 'visible',
                        mt: 1.5,
                        '& .MuiMenuItem-root': {
                            fontSize: '0.875rem',
                            py: 1,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleProfile}>
                    <ListItemIcon>
                        <PersonIcon fontSize="small" />
                    </ListItemIcon>
                    Meu Perfil
                </MenuItem>
                <MenuItem onClick={handleSettings}>
                    <ListItemIcon>
                        <SettingsIcon fontSize="small" />
                    </ListItemIcon>
                    Configurações
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    Sair
                </MenuItem>
            </Menu>
        </>
    );
}

export default UserDisplay;